import styles from './new-sales.module.scss';
import { Col, Row } from 'reactstrap';
import { UseTableHook } from '../../requestUtils';
import PageTitle from '../../page-title/page-title';
import { booleanHeader, Box, Container, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, SumRows, textHeader } from '@frontend-workspace/react-shared-lib';
import NewSalesGrid from '../new-sales-grid/new-sales-grid';
import { INewSales } from '../../_models/new-sales';

import FullTable from '../../full-table/full-table';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface NewSalesProps { }

export function NewSales(props: NewSalesProps) {
  // const { data, onDateChange, isLoading, dateRange, productFilter, getData } = UseTableHook<INewSales>(`reports/new-sales`);
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }
      }>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5" >

            <PageTitle title={t("app.newSales")} subtitle={`(${t("standard.report")})`} />
            < FullTable
              url="reports/new-sales"
              headers={
                CreateHeaders([
                  textHeader("companyNumber", "Kundenr.", HeaderSizeEnum.MEDIUM),
                  textHeader("companyName", "Kundenavn", HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("department", "Avdeling", HeaderSizeEnum.LARGE),
                  textHeader("contractResponsible", "Kontraktansvarlig", HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("sellerName", "Selger", HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("licenseNumber", "Lisensnr.", HeaderSizeEnum.MEDIUM),
                  textHeader("interval", "Periode", HeaderSizeEnum.SMALL, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header"
                  }),
                  textHeader("seats", "Antall seter", HeaderSizeEnum.MEDIUM, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  textHeader("setupVismaId", "Etableringsvare", HeaderSizeEnum.EXTRA_LARGE),
                  textHeader("nimbusCode", "Kode", HeaderSizeEnum.SMALL),
                  textHeader("productName", "Etableringsvarenavn", HeaderSizeEnum.EXTRA_LARGE),
                  dateHeader("activationDate", "Fakturadato"),
                  currencyHeader("invoiceAmount", "Fakturabeløp", HeaderSizeEnum.LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  currencyHeader("saleCostPrice", "Kostpris salg", HeaderSizeEnum.LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  currencyHeader("saleContributionMargin", "DB salg", HeaderSizeEnum.LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  currencyHeader("recurringPrice", "Gjentagende pris", HeaderSizeEnum.LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  currencyHeader("recurringCostPrice", "Kostpris gjentagende", HeaderSizeEnum.LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  currencyHeader("recurringContributionMargin", "ACV", HeaderSizeEnum.LARGE, {
                    cellStyle: { justifyContent: 'right' },
                    headerClass: "ag-right-aligned-header",
                    summary: SumRows
                  }),
                  textHeader("productGroup", "Produktgruppe", HeaderSizeEnum.EXTRA_LARGE),
                  booleanHeader("isDifferentInVisma", "Ulik i Visma")
                ])}
              tableConfigName="newSalesReport"
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default NewSales;